import {internalApi} from "../../../common/axios";
import {useMutationBase, useQueryBase} from "../../../shared/hooks/useHookBase";
import {buildUrl} from "../../../shared/utils/net";

const fetchShoppingRoad = async ({showExpired} = {}) => {
    const url = buildUrl('/events/shopping_road', showExpired ? {showExpired: true} : {});
    const response = await internalApi.get(url);
    return response.data.rows;
}

export const useShoppingRoad = (params) => {
    return useQueryBase(['shoppingRoad', params], () => fetchShoppingRoad(params));
}

const changeShoppingRoadOnOff = async ({seq, onOff}) => {
    await internalApi.post(buildUrl('/events/shopping_road/onoff'), {seq, onOff});
}

export const useChangeShoppingRoadOnOff = () => {
    return useMutationBase('shoppingRoad', changeShoppingRoadOnOff);
}

const fetchShoppingRoadManager = async () => {
    const url = buildUrl('/events/shopping_road/manager');
    const response = await internalApi.get(url);
    return response.data;
}

export const useShoppingRoadManager = () => {
    return useQueryBase('shoppingRoadManager', fetchShoppingRoadManager);
}

const fetchShoppingRoadGroup = async () => {
    const url = buildUrl('/events/shopping_road/group');
    const response = await internalApi.get(url);
    return response.data;
}

export const useFetchShoppingRoadGroup = () => {
    return useQueryBase('shoppingRoadGroup', fetchShoppingRoadGroup);
}

const fetchShoppingRoadGroupInfo = async (params) => {
    const url = buildUrl('/events/shopping_road/group_info', params);
    const response = await internalApi.get(url);
    return response.data.rows;
}

export const useFetchShoppingRoadGroupInfo = (params, options = {}) => {
    return useQueryBase(
        ['shoppingRoadGroupInfo', params],
        () => fetchShoppingRoadGroupInfo(params),
        {
            enabled: options.enabled !== undefined ? options.enabled : true,
            ...options
        }
    );
};